import React, { useEffect, useState } from "react";
import { getEmailPreferences, updateEmailPreferences } from "./emailPreferencesService";
import "./EmailPreferences.css";

const PREFS = [
 { key: "reminderEnabled", label: "Session Reminders", desc: "Get reminded before sessions start" },
 { key: "marketingEnabled", label: "Marketing Emails", desc: "Offers, promotions & new plans" },
 { key: "announcementEnabled", label: "Announcements", desc: "Feature updates & general news" },
];

const EmailPreferences = () => {
 const [prefs, setPrefs] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const load = async () => {
 const res = await getEmailPreferences();
 if (res.status === 200 && res.data) setPrefs(res.data);
 else setPrefs({ marketingEnabled: true, announcementEnabled: true, reminderEnabled: true });
 setLoading(false);
 };
 load();
 }, []);

 const handleToggle = async (key) => {
 const updated = { ...prefs, [key]: !prefs[key] };
 const prev = { ...prefs };
 setPrefs(updated);

 const res = await updateEmailPreferences(updated);
 if (res.status !== 200) {
 setPrefs(prev);
 alert("Failed to update preference");
 }
 };

 if (loading) return null;

 return (
 <div className="email-pref-section">
 <h3 className="email-pref-title">Email Preferences</h3>

 <div className="email-pref-list">
 {PREFS.map((p) => (
 <div key={p.key} className="email-pref-item">
 <div className="email-pref-info">
 <span className="email-pref-label">{p.label}</span>
 <span className="email-pref-desc">{p.desc}</span>
 </div>
 <label className="email-pref-toggle">
 <input type="checkbox" checked={prefs[p.key]} onChange={() => handleToggle(p.key)} />
 <span className="email-pref-slider" />
 </label>
 </div>
 ))}
 </div>

 <p className="email-pref-note">
 ℹ️ Transactional emails (booking confirmations, OTP, payments) cannot be disabled.
 </p>
 </div>
 );
};

export default EmailPreferences;
